import Icon from '../components/Icon.vue'

Icon.register({
  allergies: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 112c17.6 0 32 14.4 32 32v176.1c-0.2 14-1.9 28.6-5.1 42.3l-26.5 112.7c-5.1 21.7-24.4 37-46.7 37h-197.6c-15.3 0-29.8-7.4-38.8-19.8l-125.6-172.7c-13-17.9-9.1-42.9 8.8-55.9s42.9-9.1 55.9 8.8l23.6 32.5v-241c0-17.6 14.4-32 32-32s32 14.4 32 32v152c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-184c0-17.6 14.4-32 32-32s32 14.4 32 32v184c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-152c0-17.6 14.4-32 32-32s32 14.4 32 32v152c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72c0-17.6 14.4-32 32-32zM176 416c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM176 320c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM240 448c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM240 352c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM304 384c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM336 448c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM368 320c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/allergies.js
// module id = 595
// module chunks = 0